import { render, staticRenderFns } from "./trainModel.vue?vue&type=template&id=351abb00&scoped=true&"
import script from "./trainModel.vue?vue&type=script&lang=js&"
export * from "./trainModel.vue?vue&type=script&lang=js&"
import style0 from "./trainModel.vue?vue&type=style&index=0&id=351abb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351abb00",
  null
  
)

export default component.exports